import React from 'react';
import { getUserFromToken } from '../Services/utils';

const PaymentOptions = () => {
  const getTenantId = () => {
    const token = getUserFromToken();
    const groupsid = token?.groupsid;
    return groupsid;
  };

  return (
    <>
      <div className="pt-3 mt-3 d-flex align-items-center justify-content-center">
        <h2>Select a Plan </h2>
      </div>
      <div className="d-flex font-weight-bold align-items-center justify-content-center">
        <span>After completion, refresh the page</span>
      </div>
      <div className="d-flex font-weight-bold align-items-center justify-content-center">
        You have Basic Premium Plan, which allows up to 2 Users and 2 active Jobs
      </div>
      <div className="pt-2 mt-2 d-flex flex-wrap align-items-center justify-content-center">
        <div className="m-3">
          <stripe-buy-button
            buy-button-id="buy_btn_1OlwnfL1k1OczN4t0igSUTuX"
            publishable-key="pk_test_51Ohm2mL1k1OczN4tCuW7nHVJtGNXaQAYOElHEcmKVGA3YXZEt7dOfdvi2FOiNFb31MfN09lu3vWepDZja8TULzT400msORT89m"
          />
        </div>
        <div className="m-3">
          <stripe-buy-button
            buy-button-id="buy_btn_1OhnkBL1k1OczN4tWkPP1ZDW"
            publishable-key="pk_test_51Ohm2mL1k1OczN4tCuW7nHVJtGNXaQAYOElHEcmKVGA3YXZEt7dOfdvi2FOiNFb31MfN09lu3vWepDZja8TULzT400msORT89m"
            client-reference-id={getTenantId()}
          />
        </div>
        <div className="m-3">
          <stripe-buy-button
            buy-button-id="buy_btn_1OjHH5L1k1OczN4t9hC7Ggfn"
            publishable-key="pk_test_51Ohm2mL1k1OczN4tCuW7nHVJtGNXaQAYOElHEcmKVGA3YXZEt7dOfdvi2FOiNFb31MfN09lu3vWepDZja8TULzT400msORT89m"
            client-reference-id={getTenantId()}
          />
        </div>
        <div className="m-3">
          <stripe-buy-button
            buy-button-id="buy_btn_1OjNCWL1k1OczN4trTcaAltj"
            publishable-key="pk_test_51Ohm2mL1k1OczN4tCuW7nHVJtGNXaQAYOElHEcmKVGA3YXZEt7dOfdvi2FOiNFb31MfN09lu3vWepDZja8TULzT400msORT89m"
            client-reference-id={getTenantId()}
          />
        </div>
      </div>
      <div className="d-flex flex-wrap align-items-center justify-content-center">
        <div className="m-3">
          <stripe-buy-button
            buy-button-id="buy_btn_1OjNFXL1k1OczN4telm1ldF9"
            publishable-key="pk_test_51Ohm2mL1k1OczN4tCuW7nHVJtGNXaQAYOElHEcmKVGA3YXZEt7dOfdvi2FOiNFb31MfN09lu3vWepDZja8TULzT400msORT89m"
            client-reference-id={getTenantId()}
          />
        </div>
        <div className="m-3">
          <stripe-buy-button
            buy-button-id="buy_btn_1OjNJ3L1k1OczN4tSpMnnuh0"
            publishable-key="pk_test_51Ohm2mL1k1OczN4tCuW7nHVJtGNXaQAYOElHEcmKVGA3YXZEt7dOfdvi2FOiNFb31MfN09lu3vWepDZja8TULzT400msORT89m"
            client-reference-id={getTenantId()}
          />
        </div>
      </div>
    </>
  );
};

export default PaymentOptions;
